import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Musik",
    text: "House in all seinen Facetten — gespielt wird nur, was uns selbst um drei Uhr nachts noch auf dem Floor hält.",
  },
  {
    n: "02",
    title: "Location",
    text: "Immer die heißesten und besten Locations in Köln. Vom Rooftop bis in den Keller.",
  },
  {
    n: "03",
    title: "Menschen",
    text: "Sichere, angenehme Atmosphäre für alle. Jeder Abend wird zum unvergesslichen Erlebnis.",
  },
];

export const Manifesto = () => (
  <section id="manifest" className="border-b-2 border-[#f4f4f2]" data-testid="manifesto-section">
    <div className="grid md:grid-cols-3">
      {CHAPTERS.map((c, i) => (
        <Reveal
          key={c.n}
          delay={i * 0.12}
          className={`group transition-colors duration-300 hover:bg-[#f4f4f2] ${i < CHAPTERS.length - 1 ? "border-b-2 border-[#f4f4f2] md:border-b-0 md:border-r-2" : ""}`}
        >
          <div className="px-7 py-10 md:px-9 md:py-14" data-testid={`manifesto-chapter-${c.n}`}>
            <span className="font-mono2 text-xs font-bold tracking-[0.2em] text-[#a8a8a4] transition-colors duration-300 group-hover:text-[#0a0a0a]">
              {c.n}
            </span>
            <h3 className="font-display mt-4 text-2xl uppercase tracking-tight transition-colors duration-300 group-hover:text-[#0a0a0a] md:text-3xl">
              {c.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed transition-colors duration-300 group-hover:text-[#0a0a0a] md:text-base">
              {c.text}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
